import cx from 'classnames'
import type React from 'react'
import { useEffect, useState } from 'react'

import css from '../../../../Import.module.scss'

type Props = {
  children: React.ReactNode
  initialSize?: FrameSize
}

export type FrameSize = {
  width: number
  height: number
}

export const CrawlerLoadingFrame: React.FC<Props> = ({
  children,
  initialSize,
}) => {
  const [expanded, setExpanded] = useState(!initialSize)

  useEffect(() => {
    const animationFrame = requestAnimationFrame(() => setExpanded(true))

    return () => cancelAnimationFrame(animationFrame)
  }, [])

  return (
    <div
      className={cx(css.container, css.crawlerLoading)}
      style={expanded ? undefined : initialSize}
      data-testid="crawling_processing"
    >
      {children}
    </div>
  )
}
